import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import PlanDetails from "../components/planDetails.jsx";
import Footer from "../components/footer.jsx";

function PlanDetailspage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <PlanDetails/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default PlanDetailspage;
